/* Ossidiana 2026-10-23: barra fissa mobile.
   - Dopo aver superato il pulsante principale (tema: animate-sticky[animate]) aggiunge al carrello.
   - Se il pulsante principale è già a schermo, aggiunge al carrello.
   - Altrimenti porta a colori/taglie e le evidenzia, invece di aggiungere la variante preselezionata. */
(function(){
  var mq = window.matchMedia('(max-width: 749px)');

  function pickerTarget(){
    var list = document.querySelectorAll('variant-selects, variant-radios, select[name^="properties["]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.closest('.sticky-cart, .product-sticky-cart')) continue;
      if (el.tagName === 'SELECT') {
        if (el.offsetParent === null) continue;
        return el.closest('.product-form__input') || el.parentElement;
      }
      if (el.getBoundingClientRect().height > 0) return el;
    }
    return null;
  }

  document.addEventListener('click', function(e){
    if (!mq.matches) return;
    var btn = e.target.closest('.sticky-cart__form button[name="add"]');
    if (!btn) return;
    var sticky = btn.closest('animate-sticky');
    if (sticky && sticky.hasAttribute('animate')) return;

    var sentinel = document.querySelector('.animate-sticky-sentinel');
    if (sentinel) {
      var top = sentinel.getBoundingClientRect().top;
      if (top > 0 && top < window.innerHeight - 90) return;
    }

    var target = pickerTarget() || sentinel;
    if (!target) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    target.classList.add('oss-flash');
    setTimeout(function(){ target.classList.remove('oss-flash'); }, 1800);
  }, true);
})();
